<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>{{ operacao }} Aplicação</span>
                </h4>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <b-row>
                    <b-col sm="12" md="4" lg="3" xl="3">
                        <b-form-group>
                            <label>Nome da Aplicação</label>
                            <b-form-input
                                v-model="codigo"
                                @input="$v.codigo.$touch()"
                                :state="$v.codigo.$error ? false : null"
                                :disabled="desabilitarForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >O código da aplicação é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="8" lg="9" xl="7">
                        <b-form-group>
                            <label>Descrição</label>
                            <b-form-input
                                v-model="descricao"
                                @input="$v.descricao.$touch()"
                                :state="$v.descricao.$error ? false : null"
                                :disabled="desabilitarForm"
                            ></b-form-input>
                            <b-form-invalid-feedback
                                >A descrição da aplicação é
                                obrigatória</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4" lg="3" xl="2">
                        <b-form-group>
                            <label>Acesso válido até</label>
                            <date-picker
                                v-model="fimVigencia"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                :disabled="desabilitarForm"
                                v-show="acao != 'D'"
                                ref="dpValidadeAcesso"
                            ></date-picker>
                            <b-form-input
                                v-if="acao == 'D'"
                                :value="fimVigencia"
                                :disabled="desabilitarForm"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4" lg="3" xl="2" v-if="acao == 'D'">
                        <b-form-group>
                            <label>Status</label>
                            <div>
                                <app-status
                                    v-if="aplicacao"
                                    class="statusForm"
                                    :status="aplicacao.statusDescr"
                                ></app-status>
                                <btn-ativar-desativar
                                    :aplicacao="aplicacaoDto"
                                    @atualizarErros="erros = $event"
                                    @atualizarAplicacao="aplicacao = $event"
                                    v-if="acao == 'D' && aplicacao"
                                ></btn-ativar-desativar>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4" lg="3" xl="2" v-if="acao == 'D'">
                        <b-form-group>
                            <label>Token válido até</label>
                            <b-form-input
                                v-if="aplicacao"
                                :value="
                                    $moment(aplicacao.validadeToken).format(
                                        'DD/MM/YYYY HH:mm'
                                    )
                                "
                                :disabled="desabilitarForm"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4" lg="3" xl="2" v-if="acao == 'D'">
                        <b-form-group>
                            <label>Atualizado em</label>
                            <b-form-input
                                v-if="aplicacao"
                                :value="
                                    $moment(aplicacao.dataAtualizacao).format(
                                        'DD/MM/YYYY HH:mm'
                                    )
                                "
                                :disabled="desabilitarForm"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="acao == 'D'">
                    <b-col>
                        <h5 class="heading-1 mb-4">
                            <span>Token</span>
                        </h5>
                        <span class="token mb-4" v-if="aplicacao">
                            {{ aplicacao.token }}
                        </span>
                    </b-col>
                </b-row>
                <aplicacao-regras-acesso
                    @atualizarRegrasSelecionadas="
                        regrasAcessoSelecionadas = $event
                    "
                    :aplicacao="aplicacao"
                    :acao="acao"
                ></aplicacao-regras-acesso>
                <btn-atualizar v-if="acao == 'D'"></btn-atualizar>
                <btn-recriar-token
                    :aplicacao="aplicacaoDto"
                    @atualizarAplicacao="aplicacao = $event"
                    v-if="acao == 'D'"
                ></btn-recriar-token>
                <btn-salvar
                    :acao="acao"
                    :aplicacao="aplicacaoDto"
                    @atualizarErros="erros = $event"
                    @atualizarAplicacao="aplicacao = $event"
                    v-if="acao != 'D'"
                ></btn-salvar>
                <app-btn-voltar :rota="voltarRota"></app-btn-voltar>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import AplicacoesServicos from './AplicacoesServicos.js'
import { required } from 'vuelidate/lib/validators'
import AplicacaoRegrasAcesso from './AplicacaoRegrasAcesso'
import BtnSalvar from './BtnSalvar'
import BtnAtualizar from './BtnAtualizarAplicacao'
import BtnAtivarDesativar from './BtnAtivarDesativar'
import BtnRecriarToken from './BtnRecriarToken'

export default {
    components: {
        AplicacaoRegrasAcesso,
        BtnSalvar,
        BtnAtualizar,
        BtnAtivarDesativar,
        BtnRecriarToken
    },

    data() {
        return {
            codigo: null,
            descricao: null,
            fimVigencia: null,
            regrasAcessoSelecionadas: [],
            erros: [],
            aplicacao: null
        }
    },

    methods: {
        obterAplicacao() {
            this.$store.dispatch('addRequest')
            AplicacoesServicos.obterPorId(this.$route.params.aplicacaoId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.aplicacao = response.data
                            // this.preencherFormulario()
                        } else {
                            this.$toast.error(
                                'Erro ao obter dados da aplicação',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        preencherFormulario() {
            this.codigo = this.aplicacao.codigo
            this.descricao = this.aplicacao.descricao
            this.fimVigencia = this.aplicacao.fimVigencia
                ? this.$moment(this.aplicacao.fimVigencia).format('DD/MM/YYYY')
                : 'NÃO ESPECIFICADO'
        }
    },

    created() {
        if (this.acao != 'I' && !this.aplicacao) {
            this.obterAplicacao()
        }
    },

    mounted() {
        if (this.acao == 'I') {
            this.$refs.dpValidadeAcesso.dp.maxDate(this.dataMaxAcesso)
        }
    },

    computed: {
        acao() {
            let retorno = ''
            if (this.$route.name == 'Aplicacoes_Inserir') {
                retorno = 'I'
            } else if (this.$route.name == 'Aplicacoes_Atualizar') {
                retorno = 'A'
            } else if (this.$route.name == 'Aplicacoes_Detalhar') {
                retorno = 'D'
            }
            return retorno
        },

        operacao() {
            let retorno = ''
            if (this.acao == 'I') {
                retorno = 'Inserir'
            } else if (this.acao == 'A') {
                retorno = 'Atualizar'
            }
            return retorno
        },

        voltarRota() {
            if (this.acao == 'I' || this.acao == 'D') {
                return 'Aplicacoes'
            } else {
                return ''
            }
        },

        aplicacaoDto() {
            let dto = {
                codigo: this.codigo,
                descricao: this.descricao,
                fimVigencia:
                    this.fimVigencia && this.fimVigencia != 'NÃO ESPECIFICADO'
                        ? this.$moment(this.fimVigencia, 'DD/MM/YYYY').format(
                              'YYYY-MM-DD'
                          )
                        : null,
                regrasAcesso: this.regrasAcessoSelecionadas,
                valida: !this.$v.$invalid
            }
            if ((this.acao == 'A' || this.acao == 'D') && this.aplicacao) {
                dto.aplicacaoId = this.aplicacao.aplicacaoId
            }
            if (this.acao == 'D' && this.aplicacao) {
                dto.status = this.aplicacao.status
            }
            return dto
        },

        desabilitarForm() {
            return this.acao == 'D'
        },

        dataMaxAcesso() {
            return this.$moment(new Date()).add(15, 'y')
        }
    },

    watch: {
        aplicacao() {
            this.preencherFormulario()
            this.$refs.dpValidadeAcesso.dp.maxDate(
                this.$moment(this.aplicacao.validadeToken)
            )
        }

        // $route(to, from) {
        //     if (to.name == 'Aplicacoes_Atualizar') {

        //     }
        // }
    },

    validations: {
        codigo: {
            required
        },
        descricao: {
            required
        },
        regrasAcesso: {
            regrasOk() {
                return this.regrasAcessoSelecionadas.length > 0
            }
        }
    }
}
</script>

<style>
.token {
    max-width: 700px;
    word-wrap: break-word;
    display: block;
    white-space: normal;
}

.statusForm {
    margin-top: -5px;
    font-size: 1.2em;
}
</style>
